import { createFileRoute } from "@tanstack/react-router"
import { procedureTypeSettingsFieldsViewStaticData } from "src/views/ProcedureTypeSettingsFieldsView/constants"
import { ProcedureTypeSettingsFieldsView } from "src/views/ProcedureTypeSettingsFieldsView/ProcedureTypeSettingsFieldsView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/fields",
)({
	component: ProcedureTypeSettingsFieldsView,
	staticData: procedureTypeSettingsFieldsViewStaticData,
})
